import { ApiProperty } from '@nestjs/swagger';

export class EmployeeBuyerMappingDto {
  @ApiProperty()
  id: number;

  // @ApiProperty()
  // employeeName: string;

  // @ApiProperty()
  // buyerName: string;
  
  @ApiProperty()
  employeeId: number;  // Add employeeId to the DTO

  @ApiProperty()
  buyerId: number; 

  @ApiProperty()
  isActive: boolean;
  createdAt : Date;

  @ApiProperty()
  createdUser : string;
  updatedAt : Date;
  
  @ApiProperty()
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

}

